"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MsalLayer = exports.MsalPlugin = void 0;
const main_1 = require("./main");
Object.defineProperty(exports, "MsalLayer", { enumerable: true, get: function () { return main_1.MsalLayer; } });
const vue_demi_1 = require("vue-demi");
class MsalPlugin {
    // to annoying to type Vue since it's supporting both vue2 and vue
    static install(Vue, options) {
        if (vue_demi_1.isVue2) {
            Vue.prototype.$msal = new main_1.MsalLayer(options);
        }
        else if (vue_demi_1.isVue3) {
            Vue.config.globalProperties.$msal = new main_1.MsalLayer(options);
        }
        else {
            throw "Should either be vue2 or vue3, can't detect either";
        }
    }
}
exports.MsalPlugin = MsalPlugin;
